import React, { useState } from 'react';
import BottomSheet from '../BottomSheet/BottomSheet';
import './ClubDetailBottomSheet.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  
  faHeart, 
  faClock, 
  faMapMarkerAlt,
  faTimes,
  
  faArrowUpFromBracket,
  
  faMusic,
  faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import { faGoogle, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import { toggleLikeClub } from '../../store/slices/clubsSlice';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { timeManager } from '../../utils/timeUtils';


const ClubDetailBottomSheet = ({ 
  isOpen, 
  onClose, 
  club = null 
}) => {

  
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const { likedClubs } = useSelector((state) => state.clubs);
  const [showOperatingHoursDropdown, setShowOperatingHoursDropdown] = useState(false);
  
  // 더미 데이터
  const dummyClub = {
    name: "데이앤 나잇",
    location: "이태원",
    status: "오후 9:00에 영업 종료",
    distance: "160m",
    like_count: 408,
    matchPercent: 85,
    description: "이태원 핫한 클럽\n혁신적인 음악과 분위기\n매일 다른 DJ 라인업",
    images: [
      "https://via.placeholder.com/300x200/1a1a2e/eee?text=Club+Image+1",
      "https://via.placeholder.com/300x200/16213e/eee?text=Club+Image+2",
      "https://via.placeholder.com/300x200/0f0f1a/eee?text=Club+Image+3"
    ],
    operatingHours: "오늘 9:00에 영업종료",
    operating_hours: "Everyday 21:00-late",
    address: "서울 용산구 이태원로 146",
    phone: "032-727-2233",
    instagram_url: "https://instagram.com/club_instagram"
  };

  const displayClub = club || dummyClub;

  // 좋아요 상태 확인
  const isLiked = club ? likedClubs.includes(club.id) : false;

  // 이미지 뷰어 상태
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);
  const [viewerImages, setViewerImages] = useState([]);

  // 이미지 클릭 핸들러
  const handleImageClick = (images, idx) => {
    setViewerImages(images);
    setViewerIndex(idx);
    setViewerOpen(true);
  };

  // 좋아요 토글 핸들러
  const handleLikeClick = () => {
    if (!user || !isAuthenticated) {
      alert('로그인이 필요합니다.');
      return;
    }
    
    if (!club) return;
    
    const isCurrentlyLiked = likedClubs.includes(club.id);
    dispatch(toggleLikeClub({ userId: user.id, clubId: club.id, isLiked: isCurrentlyLiked }))
      .unwrap()
      .catch((error) => console.error('Error toggling like:', error));
  };

  // 운영시간 파싱 및 당일 상태 계산 함수 - timeManager 사용
  const getTodayOperatingStatus = (operatingHours) => {
    if (!operatingHours) {
      return { status: '정보 없음', time: '' };
    }

    // timeManager 확인
    if (typeof timeManager === 'undefined') {
      return { status: '정보 없음', time: '' };
    }

    // timeManager를 사용하여 압축 포맷과 기존 포맷 모두 지원
    const result = timeManager.getCurrentOperatingStatus(operatingHours);
    
    return result;
  };

  // 운영 상태 계산
  const operatingStatus = getTodayOperatingStatus(displayClub.operating_hours);
  
  // 전체 요일 영업시간 정보
  const allDaysSchedule = timeManager?.getAllDaysSchedule ? 
    timeManager.getAllDaysSchedule(displayClub.operating_hours) : [];
  

  
  // 영업시간 드롭다운 토글
  const toggleOperatingHoursDropdown = () => {
    setShowOperatingHoursDropdown(!showOperatingHoursDropdown);
  };

  // 인스타그램 링크 열기 핸들러
  const handleInstagramClick = (e) => {
    e.stopPropagation(); // 부모 클릭 이벤트 방지
    const instagramUrl = displayClub.instagram_url;
    if (instagramUrl) {
      window.open(instagramUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="club-detail-bottomsheet-wrapper">
      <BottomSheet
        isOpen={isOpen}
        onClose={onClose}
        backgroundColor="#232323"
        snapPoints={[0.8]}
        initialSnap={0}
        showDragHandle={true}
      >
        <div className="club-detail-bottomsheet-container">
          {/* 닫기 버튼 */}
          <button className="club-detail-bottomsheet-close-btn" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>

          {/* 헤더 섹션 */}
          <div className="club-detail-bottomsheet-header">
            <div className="club-detail-bottomsheet-title-section">
              <h1 className="club-detail-bottomsheet-name">{displayClub.name}</h1>
              <p className="club-detail-bottomsheet-location">{displayClub.location}</p>
              {/* 운영시간/상태를 헤더에도 노출 */}
              <p className="club-detail-bottomsheet-status">
                {operatingStatus.status}
                {operatingStatus.time && ` · ${operatingStatus.time}`}
              </p>
            </div>
            
            {/* 액션 버튼들 */}
            <div className="club-detail-bottomsheet-actions">
              <button className="club-detail-bottomsheet-action-btn club-detail-bottomsheet-match-btn">
                <FontAwesomeIcon icon={faMusic} />
                <span>{displayClub.matchPercent || 0}%</span>
              </button>
              
              <button 
                className="club-detail-bottomsheet-action-btn club-detail-bottomsheet-save-btn"
                onClick={handleLikeClick}
              >
                <FontAwesomeIcon 
                  icon={isLiked ? faHeart : faHeartRegular} 
                  style={{ color: isLiked ? '#ff4757' : '#ffffff' }}
                />
                <span>{displayClub.like_count || displayClub.saveCount || 0}</span>
              </button>
              
              {/*
              <button className="club-detail-bottomsheet-action-btn club-detail-bottomsheet-review-btn">
                <FontAwesomeIcon icon={faGoogle} />
                <span>리뷰</span>
              </button>
              */}
              
              <button className="club-detail-bottomsheet-action-btn club-detail-bottomsheet-share-btn">
                <FontAwesomeIcon icon={faArrowUpFromBracket} />
                <span>공유</span>
              </button>
            </div>
          </div>

          {/* 이미지 갤러리 */}
          <div className="club-detail-bottomsheet-images">
            {displayClub.images && displayClub.images.map((image, index) => (
              <div key={index} className="club-detail-bottomsheet-image-container">
                <img 
                  src={image} 
                  alt={`${displayClub.name} ${index + 1}`} 
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleImageClick(displayClub.images, index)}
                />
              </div>
            ))}
          </div>

          {/* 세부 정보 섹션 */}
          <div className="club-detail-bottomsheet-info">
            {/* 영업시간 */}
            <div className="club-detail-bottomsheet-info-item club-detail-bottomsheet-operating-hours">
              <div className="club-detail-bottomsheet-info-icon">
                <FontAwesomeIcon icon={faClock} />
              </div>
              <div className="club-detail-bottomsheet-info-content">
                <div 
                  className="club-detail-bottomsheet-operating-hours-main"
                  onClick={toggleOperatingHoursDropdown}
                >
                  <div>
                    <span className="club-detail-bottomsheet-info-label operating-status">{operatingStatus.status}</span>
                    <span className="club-detail-bottomsheet-info-value">
                      {operatingStatus.time || (displayClub.operating_hours ? "" : "영업시간 정보 없음")}
                    </span>
                  </div>
                  <FontAwesomeIcon 
                    icon={faChevronDown} 
                    className={`club-detail-bottomsheet-dropdown-icon ${showOperatingHoursDropdown ? 'expanded' : ''}`}
                  />
                </div>
                
                {showOperatingHoursDropdown && allDaysSchedule.length > 0 && (
                  <div className="club-detail-bottomsheet-operating-hours-dropdown">
                    {allDaysSchedule.map((dayInfo, index) => (
                      <div 
                        key={index} 
                        className={`club-detail-bottomsheet-operating-hours-day ${dayInfo.isToday ? 'today' : ''}`}
                      >
                        <span className="club-detail-bottomsheet-operating-hours-day-name">
                          {dayInfo.day}
                        </span>
                        <span className={`club-detail-bottomsheet-operating-hours-day-time ${dayInfo.status === '휴무' ? 'closed' : ''}`}>
                          {dayInfo.status === '휴무' ? '휴무' : dayInfo.time}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* 주소 */}
            <div className="club-detail-bottomsheet-info-item">
              <div className="club-detail-bottomsheet-info-icon">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </div>
              <div className="club-detail-bottomsheet-info-content">
                <span className="club-detail-bottomsheet-info-label">주소</span>
                <span className="club-detail-bottomsheet-info-value">{displayClub.address || "주소 정보 없음"}</span>
              </div>
            </div>

            {/* 인스타그램 */}
            <div className="club-detail-bottomsheet-info-item" onClick={handleInstagramClick}>
              <div className="club-detail-bottomsheet-info-icon">
                <FontAwesomeIcon icon={faInstagram} />
              </div>
              <div className="club-detail-bottomsheet-info-content">
                <span className="club-detail-bottomsheet-info-label">인스타</span>

              </div>
            </div>
          </div>
        </div>
        {/* 이미지 뷰어 */}
        {viewerOpen && (
          <Lightbox
            mainSrc={viewerImages[viewerIndex]}
            nextSrc={viewerImages[(viewerIndex + 1) % viewerImages.length]}
            prevSrc={viewerImages[(viewerIndex + viewerImages.length - 1) % viewerImages.length]}
            onCloseRequest={() => setViewerOpen(false)}
            onMovePrevRequest={() =>
              setViewerIndex((viewerIndex + viewerImages.length - 1) % viewerImages.length)
            }
            onMoveNextRequest={() =>
              setViewerIndex((viewerIndex + 1) % viewerImages.length)
            }
            imagePadding={0}
            enableZoom={false}
            clickOutsideToClose={true}
            animationDuration={300}
          />
        )}
      </BottomSheet>
    </div>
  );
};

export default ClubDetailBottomSheet; 